export const faqs = [
  {
    id: 0,
    question: "What is the Eratek 1KB Initiative?",
    answer:
      "It's a free program to help local African businesses gain online visibility and accessibility.",
  },
  {
    id: 1,
    question: "How does this help my business?",
    answer:
      "We make it easier for potential customers to find you online, helping you reach more customers and grow your business.",
  },
  {
    id: 2,
    question: "Is this service free? ",
    answer:
      "Yes, the Eratek 1kb initiative offers a free solution to help African businesses embrace digitalization. ",
  },
  {
    id: 3,
    question: "What information do I need to provide to get started? ",
    answer: `You’ll need to provide basic details about your business, such as your business name, contact information, location, and services offered. we curated a series of questions on a sign-up form to help you.`,
  },
  {
    id: 4,
    question: "How long does it take to see results after joining? ",
    answer:
      "Results may vary, but many businesses start seeing increased visibility and engagement within weeks of completing their digital profile. ",
  },
  {
    id: 5,
    question: "Will you help with the setup?  ",
    answer:
      "Yes, we guide you through the setup process and ensure your profile is optimized for maximum visibility.  ",
  },
  {
    id: 6,
    question: "Can I update my business information after it's set up? ",
    answer:
      "Absolutely! You’ll have access to update your business details whenever necessary. ",
  },
  {
    id: 7,
    question: "Do I need any technical skills to join?",
    answer:
      "No technical skills are required. We handle the setup and provide ongoing support.  ",
  },
  {
    id: 8,
    question: "How do I sign up?",
    answer: `Click the "Get Started for Free" button, and we'll guide you through the process.`,

  },
  {
    id: 9,
    question: "Can I create a Google Business Profile if I don’t have a physical store?",
    answer: `Yes, you can. Google allows businesses without a physical storefront to create a Google Business Profile. You can choose the option "Service Area Business" to list the areas where you provide your services or deliver your products.`,

  },
];
